import { render, staticRenderFns } from "./PayrollChangeRequestActivityDialog.vue?vue&type=template&id=514796ef&"
import script from "./PayrollChangeRequestActivityDialog.vue?vue&type=script&lang=ts&"
export * from "./PayrollChangeRequestActivityDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports